var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsEsports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M27.55 11.6667H12.45C10.8 11.6667 9.38338 12.9001 9.15005 14.5334L7.33338 27.2834C7.28338 27.6334 7.41671 27.8667 7.55005 28.0167C7.66671 28.1667 7.88338 28.3334 8.23338 28.3334C8.48338 28.3334 8.71671 28.2334 8.88338 28.0667L13.6167 23.3334H26.3834L31.1167 28.0667C31.2834 28.2334 31.5167 28.3334 31.7667 28.3334C32.1167 28.3334 32.3334 28.1667 32.4667 28.0167C32.6 27.8667 32.7334 27.6334 32.6834 27.2834L30.8667 14.5167C30.6167 12.9001 29.2 11.6667 27.55 11.6667ZM18.3334 18.3334H15V21.6667H13.3334V18.3334H10V16.6667H13.3334V13.3334H15V16.6667H18.3334V18.3334ZM25 16.6667C24.0834 16.6667 23.3334 15.9167 23.3334 15.0001C23.3334 14.0834 24.0834 13.3334 25 13.3334C25.9167 13.3334 26.6667 14.0834 26.6667 15.0001C26.6667 15.9167 25.9167 16.6667 25 16.6667ZM28.3334 21.6667C27.4167 21.6667 26.6667 20.9167 26.6667 20.0001C26.6667 19.0834 27.4167 18.3334 28.3334 18.3334C29.25 18.3334 30 19.0834 30 20.0001C30 20.9167 29.25 21.6667 28.3334 21.6667Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9667 26.8167L34.1501 14.05C33.6834 10.7667 30.8667 8.33337 27.5501 8.33337H12.4501C9.1334 8.33337 6.31673 10.7667 5.85007 14.05L4.0334 26.8167C3.66673 29.3834 5.65007 31.6667 8.2334 31.6667C9.36673 31.6667 10.4334 31.2167 11.2334 30.4167L15.0001 26.6667H25.0001L28.7501 30.4167C29.5501 31.2167 30.6334 31.6667 31.7501 31.6667C34.3501 31.6667 36.3334 29.3834 35.9667 26.8167ZM32.4667 28.0167C32.3334 28.1667 32.1167 28.3334 31.7667 28.3334C31.5167 28.3334 31.2834 28.2334 31.1167 28.0667L26.3834 23.3334H13.6167L8.8834 28.0667C8.71673 28.2334 8.4834 28.3334 8.2334 28.3334C7.8834 28.3334 7.66673 28.1667 7.5334 28.0167C7.40007 27.8667 7.26673 27.6334 7.31673 27.2834L9.1334 14.5167C9.3834 12.9 10.8001 11.6667 12.4501 11.6667H27.5501C29.2001 11.6667 30.6167 12.9 30.8501 14.5334L32.6667 27.3C32.7167 27.6334 32.5834 27.8667 32.4667 28.0167Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.3334H13.3333V16.6667H10V18.3334H13.3333V21.6667H15V18.3334H18.3333V16.6667H15V13.3334Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.32263,
    y1: 11.6667,
    x2: 27.6246,
    y2: 33.1289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3.98962,
    y1: 8.33337,
    x2: 32.4233,
    y2: 35.4308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10,
    y1: 13.3334,
    x2: 19.5263,
    y2: 19.9489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#675CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4840A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsEsports);
export default __webpack_public_path__ + "static/media/sports_esports.f1b5a885717c966f13245997f6bd57a3.svg";
export { ForwardRef as ReactComponent };